import {
    GET_USER_ACTIVITIES,
    GET_USER_ACTIVITIES_SUCCESS,
    GET_USER_ACTIVITIES_FAILURE,
} from "../actionTypes";

export const getActivitiesData = (payload) => ({
    type: GET_USER_ACTIVITIES,
    payload,
});

export const getActivitiesDataDataSuccess = (payload) => ({
    type: GET_USER_ACTIVITIES_SUCCESS,
    payload,
});

export const getActivitiesDataDataFailure = () => ({
    type: GET_USER_ACTIVITIES_FAILURE,
});